<div mat-dialog-content class="dialog-content" [innerHtml]="data.question"></div>
<div mat-dialog-actions class="dialog-actions-wrapper">
    <button mat-button color="primary" mat-dialog-close="true">{{ data.positiveAnswer }}</button>
    <button mat-button color="warn" mat-dialog-close>{{ data.negativeAnswer }}</button>
</div>
